// Query keys of every area, in one place so invalidation stays obvious.
export const queryKeys = {
  me: ["me"] as const,
  notifications: ["notifications"] as const,
  employees: (params?: Record<string, string | undefined>) => ["employees", params ?? {}] as const,
  assignments: (params?: Record<string, string | number | undefined>) =>
    ["assignments", params ?? {}] as const,
  syncOverview: ["sync", "overview"] as const,
  syncRuns: (params?: Record<string, string | number | undefined>) =>
    ["sync", "runs", params ?? {}] as const,
  syncJobs: (params?: Record<string, string | number | undefined>) =>
    ["sync", "jobs", params ?? {}] as const,
  absences: ["absences"] as const,
  absence: (id: string) => ["absences", id] as const,
  // Vacation and AZK form previews (extension 2: one key per kind).
  leavePreview: (kind: string, dateFrom: string, dateTo: string) =>
    ["absences", "preview", kind, dateFrom, dateTo] as const,
  dispatchAbsences: (params?: Record<string, string | number | undefined>) =>
    ["dispatch", "absences", params ?? {}] as const,
  dispatchAbsence: (id: string) => ["dispatch", "absences", id] as const,
  dispatchInbox: ["dispatch", "inbox"] as const,
  timeEntries: ["time-entries"] as const,
  week: (week?: string) => ["time-entries", "week", week ?? "current"] as const,
  entry: (id: string) => ["time-entries", "entry", id] as const,
  dispatch: ["dispatch"] as const,
  inbox: ["dispatch", "inbox"] as const,
  dispatchWeek: (employeeId: number, week?: string) =>
    ["dispatch", "week", employeeId, week ?? "current"] as const,
  adminUsers: ["admin", "users"] as const,
  adminEmployeeUsers: ["admin", "employee-users"] as const,
  adminSettings: ["admin", "settings"] as const,
  audit: (entity: string, entityId: string, limit: number) =>
    ["audit", entity, entityId, limit] as const,
  sessions: ["me", "sessions"] as const,
};
